module.exports = "images/nature_flower.8b6dc65416760c36866649f50522a731.png";